<permission-checker [roles]="roles" (contentInit)="initContent()">
  <mat-form-field class="full-width">
    <mat-label>{{items && !items.length && noItemsLabel ? noItemsLabel : label}}</mat-label>
    <mat-select [disabled]="disabled || (items && !items.length)"
                (selectionChange)="itemSelected($event)"
                [compareWith]="compareWith"
                [value]="selectedItem">
      <mat-option *ngFor="let item of items" [value]="item">{{displayWith(item)}}</mat-option>
    </mat-select>
    <mat-spinner *ngIf="!items" diameter="15" color="primary" matSuffix></mat-spinner>
  </mat-form-field>
</permission-checker>
